var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgFlowCouponPusblishedNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1464,
    height: 190.3,
    viewBox: "0 0 1464 190.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_1203",
    x: 848,
    y: 18,
    width: 172,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "\\uC0AC\\uAC01\\uD615_5787",
    x: 1357.999,
    y: 18,
    width: 93,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1687",
    "data-name": "\\uADF8\\uB8F9 1687",
    transform: "translate(17097 -12182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1667",
    "data-name": "\\uADF8\\uB8F9 1667",
    transform: "translate(-20272 6153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_802",
    "data-name": "\\uC0AC\\uAC01\\uD615 802",
    width: 84,
    height: 52,
    rx: 4,
    transform: "translate(3579 6093)",
    fill: "#f65f8d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC1C\\uC1A1_\\uC2E4\\uD328",
    "data-name": "\\uBC1C\\uC1A1 \\uC2E4\\uD328",
    transform: "translate(3621 6124)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uBC1C\uC1A1 \uC2E4\uD328"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1670",
    "data-name": "\\uADF8\\uB8F9 1670",
    transform: "translate(-19956 6153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_802-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 802",
    width: 96,
    height: 52,
    rx: 4,
    transform: "translate(3573 6093)",
    fill: "#f65f8d"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC54C\\uB9BC\\uD1A1_\\uC2E4\\uD328",
    "data-name": "\\uC54C\\uB9BC\\uD1A1 \\uC2E4\\uD328",
    transform: "translate(3621 6124)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.99,
    y: 0
  }, "\uC54C\uB9BC\uD1A1 \uC2E4\uD328"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1665",
    "data-name": "\\uADF8\\uB8F9 1665",
    transform: "translate(-18918.766 6138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 80,
    height: 52,
    rx: 4,
    transform: "translate(2670.765 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2\\uCC28_\\uBC1C\\uC1A1_LMS_",
    "data-name": "2\\uCC28 \\uBC1C\\uC1A1 (LMS)",
    transform: "translate(2710.765 6181.729)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.01,
    y: 0
  }, "2\uCC28 \uBC1C\uC1A1"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.718,
    y: 16
  }, "(LMS)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1671",
    "data-name": "\\uADF8\\uB8F9 1671",
    transform: "translate(-18687.766 6036)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 124,
    height: 52,
    rx: 4,
    transform: "translate(2648.765 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC2E4\\uD328_\\uB370\\uC774\\uD130_\\uD655\\uC778",
    "data-name": "\\uC2E4\\uD328 \\uB370\\uC774\\uD130 \\uD655\\uC778",
    transform: "translate(2710.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.836,
    y: 0
  }, "\uC2E4\uD328 \uB370\uC774\uD130 \uD655\uC778"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1672",
    "data-name": "\\uADF8\\uB8F9 1672",
    transform: "translate(-18537.766 6036)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-3",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 100,
    height: 52,
    rx: 4,
    transform: "translate(2660.765 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uC7AC_\\uBC1C\\uC1A1_\\uD544\\uC694",
    "data-name": "\\uC7AC \\uBC1C\\uC1A1 \\uD544\\uC694",
    transform: "translate(2710.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -33.74,
    y: 0
  }, "\uC7AC \uBC1C\uC1A1 \uD544\uC694"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1666",
    "data-name": "\\uADF8\\uB8F9 1666",
    transform: "translate(-19549.766 6087)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-4",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 112,
    height: 52,
    rx: 4,
    transform: "translate(2584.766 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC1C\\uC1A1_\\uCC98\\uB9AC_\\uC9C4\\uD589",
    "data-name": "\\uBC1C\\uC1A1 \\uCC98\\uB9AC \\uC9C4\\uD589",
    transform: "translate(2640.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.788,
    y: 0
  }, "\uBC1C\uC1A1 \uCC98\uB9AC \uC9C4\uD589"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1674",
    "data-name": "\\uADF8\\uB8F9 1674",
    transform: "translate(-19413.766 6087)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-5",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 84,
    height: 52,
    rx: 4,
    transform: "translate(2598.766 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uBC1C\\uC1A1_\\uC644\\uB8CC",
    "data-name": "\\uBC1C\\uC1A1 \\uC644\\uB8CC",
    transform: "translate(2640.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uBC1C\uC1A1 \uC644\uB8CC"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1660",
    "data-name": "\\uADF8\\uB8F9 1660",
    transform: "translate(-19569 6088)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_797",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    transform: "translate(2472 6158)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 52,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 51,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC54C\\uB9BC_\\uD65C\\uC131\\uD654",
    "data-name": "\\uC54C\\uB9BC \\uD65C\\uC131\\uD654",
    transform: "translate(2520.045 6189)",
    fill: "#222",
    fontSize: 13,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -29.705,
    y: 0
  }, "\uC54C\uB9BC \uD65C\uC131\uD654"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1675",
    "data-name": "\\uADF8\\uB8F9 1675",
    transform: "translate(16.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_797-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    transform: "translate(-16567.955 12195)",
    fill: "#363636",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 52,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129,
    height: 51,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC81C\\uD734\\uC0AC_LGE_\\uAD00\\uB9AC\\uC790_LMS_E-Mail_",
    "data-name": "\\uC81C\\uD734\\uC0AC/LGE \\uAD00\\uB9AC\\uC790 (LMS/E-Mail)",
    transform: "translate(-16502.955 12218)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -49.075,
    y: 0
  }, "\uC81C\uD734\uC0AC/LGE \uAD00\uB9AC\uC790"), /*#__PURE__*/React.createElement("tspan", {
    x: -37.921,
    y: 15
  }, "(LMS/E-Mail)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1676",
    "data-name": "\\uADF8\\uB8F9 1676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_797-3",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    transform: "translate(-16551 12292)",
    fill: "#363636",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 52,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 93,
    height: 51,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uACE0\\uAC1D_\\uC54C\\uB9BC\\uD1A1_",
    "data-name": "\\uACE0\\uAC1D (\\uC54C\\uB9BC\\uD1A1)",
    transform: "translate(-16504 12315)",
    fill: "#fff",
    fontSize: 13,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.232,
    y: 0
  }, "\uACE0\uAC1D"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.268,
    y: 15
  }, "(\uC54C\uB9BC\uD1A1)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1661",
    "data-name": "\\uADF8\\uB8F9 1661",
    transform: "translate(-16402 11491)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -695, 691)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_1203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_1203-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 1203",
    width: 172,
    height: 40,
    rx: 20,
    transform: "translate(848 18)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC2E4\\uD328_\\uB9AC\\uC2A4\\uD2B8_\\uC804\\uCCB4_\\uBCF4\\uAE30_",
    "data-name": "\\uC2E4\\uD328 \\uB9AC\\uC2A4\\uD2B8 \\uC804\\uCCB4 \\uBCF4\\uAE30 ",
    transform: "translate(250 734)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -61.432,
    y: 0
  }, "\uC2E4\uD328 \uB9AC\uC2A4\uD2B8 \uC804\uCCB4 \uBCF4\uAE30 ")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_152",
    "data-name": "\\uD0C0\\uC6D0 152",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(169 723)",
    fill: "#ff5b5b"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Button",
    transform: "translate(221 702)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button"))), /*#__PURE__*/React.createElement("text", {
    id: "\\uACB0\\uACFC_\\uAC12_\\uCD9C\\uB825",
    "data-name": "\\uACB0\\uACFC \\uAC12 \\uCD9C\\uB825",
    transform: "translate(-16802 12320)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uACB0\uACFC \uAC12 \uCD9C\uB825")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC790\\uB3D9\\uBC1C\\uC1A1",
    transform: "translate(-16273 12364)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC790\uB3D9\uBC1C\uC1A1")), /*#__PURE__*/React.createElement("text", {
    id: "\\uC218\\uB3D9_\\uBC1C\\uC1A1",
    "data-name": "\\uC218\\uB3D9 \\uBC1C\\uC1A1",
    transform: "translate(-15678 12265)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC218\uB3D9 \uBC1C\uC1A1")), /*#__PURE__*/React.createElement("text", {
    id: "N_LMS_",
    "data-name": "N(LMS)",
    transform: "translate(-16321 12237)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "N(LMS)")), /*#__PURE__*/React.createElement("text", {
    id: "Y",
    transform: "translate(-16321 12315)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("text", {
    id: "Y-2",
    "data-name": "Y",
    transform: "translate(-15771 12210)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Y")), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1673",
    "data-name": "\\uADF8\\uB8F9 1673",
    transform: "translate(264.961 261.279)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17361.96, 11920.72)",
    filter: "url(#\\uC0AC\\uAC01\\uD615_5787)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_5787-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 5787",
    width: 93,
    height: 40,
    rx: 20,
    transform: "translate(1358 18)",
    fill: "#363636"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uC7AC_\\uBC1C\\uC1A1_",
    "data-name": "\\uC7AC \\uBC1C\\uC1A1 ",
    transform: "translate(-15946.052 11963.721)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.644,
    y: 0
  }, "\uC7AC \uBC1C\uC1A1 ")), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_158",
    "data-name": "\\uD0C0\\uC6D0 158",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(-15988.052 11952.721)",
    fill: "#50dc75"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Button-2",
    "data-name": "Button",
    transform: "translate(-15976.962 11931.721)",
    fill: "#363636",
    fontSize: 12,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Button"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1682",
    "data-name": "\\uADF8\\uB8F9 1682",
    transform: "translate(-19965.766 13261.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89",
    "data-name": "\\uC120 89",
    y1: 166.557,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1677",
    "data-name": "\\uADF8\\uB8F9 1677",
    transform: "translate(-20681.486 13312.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-2",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-2",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-2",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1678",
    "data-name": "\\uADF8\\uB8F9 1678",
    transform: "translate(-20531.486 13312.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-3",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-3",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-3",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1679",
    "data-name": "\\uADF8\\uB8F9 1679",
    transform: "translate(-20409.486 13312.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-4",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-4",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-4",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1684",
    "data-name": "\\uADF8\\uB8F9 1684",
    transform: "translate(-19755.453 13261.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-5",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-5",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-5",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1685",
    "data-name": "\\uADF8\\uB8F9 1685",
    transform: "translate(-19593.453 13261.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-6",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-6",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-6",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1686",
    "data-name": "\\uADF8\\uB8F9 1686",
    transform: "translate(-19455.488 13261.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-7",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.766 -1044.526) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-7",
    "data-name": "\\uC120 89",
    y1: 32.87,
    transform: "translate(4.14 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-7",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1467",
    "data-name": "\\uD328\\uC2A4 1467",
    d: "M-67.548,1h5.592c9.2,0,16.656,9.354,16.656,20.893V682.1C-45.3,693.644-52.758,703-61.956,703H-118",
    transform: "translate(-16206.001 12417) rotate(90)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1472",
    "data-name": "\\uD328\\uC2A4 1472",
    d: "M72.7,531.1V20.893C72.7,9.354,65.242,0,56.044,0H-60",
    transform: "translate(-15689.896 12299) rotate(90)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1681",
    "data-name": "\\uADF8\\uB8F9 1681",
    transform: "translate(238.65 330.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1469",
    "data-name": "\\uD328\\uC2A4 1469",
    d: "M34.7,1H24.656A16.656,16.656,0,0,0,8,17.656V79.967A16.656,16.656,0,0,0,24.656,96.623H34.7",
    transform: "translate(-16828.35 11891.707)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1471",
    "data-name": "\\uD328\\uC2A4 1471",
    d: "M0,0V27.268",
    transform: "translate(-16847.232 11940.519) rotate(-90)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_37",
    "data-name": "\\uB2E4\\uAC01\\uD615 37",
    transform: "translate(-16791.65 11888.478) rotate(90)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604804039001465 7.019658088684082 L 0.8549272418022156 7.019658088684082 L 4.229865550994873 1.019854664802551 L 7.604804039001465 7.019658088684082 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039703369140625 L 1.709854602813721 6.519658088684082 L 6.749876499176025 6.519658088684082 L 4.229865550994873 2.039703369140625 M 4.229865550994873 -1.9073486328125e-06 L 8.459735870361328 7.519658088684082 L -4.76837158203125e-06 7.519658088684082 L 4.229865550994873 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_35",
    "data-name": "\\uB2E4\\uAC01\\uD615 35",
    transform: "translate(-16791.65 11984.1) rotate(90)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604804039001465 7.019658088684082 L 0.8549272418022156 7.019658088684082 L 4.229865550994873 1.019854664802551 L 7.604804039001465 7.019658088684082 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039703369140625 L 1.709854602813721 6.519658088684082 L 6.749876499176025 6.519658088684082 L 4.229865550994873 2.039703369140625 M 4.229865550994873 -1.9073486328125e-06 L 8.459735870361328 7.519658088684082 L -4.76837158203125e-06 7.519658088684082 L 4.229865550994873 -1.9073486328125e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1469-2",
    "data-name": "\\uD328\\uC2A4 1469",
    d: "M34.7,1H24.656A16.656,16.656,0,0,0,8,17.656v8.312",
    transform: "translate(-16342.7 12220)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1683",
    "data-name": "\\uADF8\\uB8F9 1683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_1473",
    "data-name": "\\uD328\\uC2A4 1473",
    d: "M86.7,25.967H24.656A16.656,16.656,0,0,1,8,9.311V1",
    transform: "translate(-16342.7 12297.033)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_38",
    "data-name": "\\uB2E4\\uAC01\\uD615 38",
    transform: "translate(-16253 12318.86) rotate(90)",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.433614730834961 7.019761085510254 L 0.8460275530815125 7.019761085510254 L 4.13982105255127 1.036762833595276 L 7.433614730834961 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.13982105255127 2.073514461517334 L 1.6920485496521 6.519761085510254 L 6.587593555450439 6.519761085510254 L 4.13982105255127 2.073514461517334 M 4.13982105255127 1.430511474609375e-06 L 8.279641151428223 7.519761085510254 L 9.5367431640625e-07 7.519761085510254 L 4.13982105255127 1.430511474609375e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlowCouponPusblishedNotification);
export default __webpack_public_path__ + "static/media/img_flow_coupon_pusblished_notification.4d36e66c556824bb79cd8429934648e2.svg";
export { ForwardRef as ReactComponent };